module.exports = __webpack_public_path__ + "img/2.e35fa82f.jpg";